<div class="app-container">
  @if (loadingQueueService.initialLoading$ | async) {
    <div class="initial-loading">
      <dpqa-loading-spinner />
    </div>
  }
  <router-outlet />
</div>
